const weblinkTypes: string[] = ['web', 'weblink'];

const programLinkTypes: string[] = [
  'carousel',
  'collection',
  'image_library',
  'video_library',
  'internal-link',
  'directory',
  'contact',
  'contact_us',
  'dam',
];

const iframeTypes: string[] = [
  'image',
  'infographic',
  'pdf',
  'brochure',
  'multi',
  'video',
  'videolink',
  'iframe',
  'iframe-link',
];

interface ResourceTypeProps {
  type: string;
}

export type ResourceType = 'webLink' | 'iframe' | 'programLink' | 'fallback';

export function getResourceType({ type }: ResourceTypeProps): ResourceType {
  if (weblinkTypes.includes(type)) return 'webLink';
  if (iframeTypes.includes(type)) return 'iframe';
  if (programLinkTypes.includes(type)) return 'programLink';
  return 'fallback';
}

export function getIframeTrackType(type: string): string {
  if (type === 'iframe' || type === 'iframe-link') return 'web';
  if (type === 'image' || type === 'infographic') return 'infographic';
  return 'pdf';
}
